export function addToArray(ebiArray, label, value, shouldDisplay, highlight) {
  if (shouldDisplay && value?.length) {
    ebiArray.push({
      label: label,
      value: value,
      highlight: !!highlight,
    });
  }
}
